var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-container"},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{class:{ rounded: _vm.rounded }},[_c('youtube',{attrs:{"video-id":_vm.src,"player-vars":_vm.playerVars}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }